import * as UI from "@iyk/music-ui"
import * as React from "react"
const Root = ({ children, position }: ShellHeader.Root.Props) => {
  const [isScrolled, setIsScrolled] = React.useState(false)

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return <header className={classForRoot({ scrolled: isScrolled, position })}>{children}</header>
}
const classForRoot = UI.cva(
  [
    "[grid-area:header]",
    "top-0 z-50",
    "grid grid-cols-[1fr_auto_1fr] items-center",
    "h-[var(--shell-header-height-mobile)] sm:h-[var(--shell-header-height-desktop)]",
    "w-[calc(100%-var(--removed-body-scroll-bar-size,0px))] px-4 text-gray-12",
    "transition-colors duration-300",
    "sm:bg-[var(--background)] sm:dark:bg-[var(--app-background-dark)]"
  ],
  {
    variants: {
      position: {
        fixed: "fixed",
        sticky: "sticky"
      },
      scrolled: {
        true: "bg-gray-1"
      }
    },
    compoundVariants: [
      {
        scrolled: false,
        position: "fixed",
        className: "bg-transparent"
      },
      {
        scrolled: false,
        position: "sticky",
        className: "bg-gray-1"
      }
    ]
  }
)

const Part = ({ children, position, className }: ShellHeader.Part.Props) => {
  return <div className={classForHeaderPart({ position, className })}>{children}</div>
}
const classForHeaderPart = UI.cva(["h-full flex items-center"], {
  variants: {
    position: {
      left: "min-w-12 justify-start self-start shrink-0",
      center: "grow px-3 justify-center",
      right: "min-w-12 justify-end self-end shrink-0"
    }
  }
})

export namespace ShellHeader {
  export namespace Root {
    export type Props = {
      children?: React.ReactNode
      position: Position
    }

    export type Position = "fixed" | "sticky"
  }

  export namespace Part {
    export type Props = {
      children?: React.ReactNode
      className?: string
      position: "left" | "center" | "right"
    }
  }

  export namespace Logo {
    export type Props = {
      className?: string
    }
  }
}

export const ShellHeader = {
  Root,
  Part
}
